module.exports = __webpack_public_path__ + "7dcdae5c2edacd5111de3353e702bd4f.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/goldencity2.jpg
// module id = 771
// module chunks = 0